<div ngForm="basicSettingsForm" class="form-horizontal">

	<vb-ui-horizontal-form-group>
		<label for="ewTitle" #uiLabel>{{ 'Title' | translate }}</label>
		<input uiControl id="ewTitle" name="title" class="form-control" required type="text" [(ngModel)]="webcast.title" #ewTitle="ngModel" trim="blur"/>
		<div *ngIf="ewTitle.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (ewTitle.errors.required) {
				{{ 'ThisFieldIsRequired' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label for="ewShortcut" #uiLabel>
			{{ 'Event_WebcastShortcut' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_ShortcutNameTooltip' | translate">
			</vb-ui-tooltip>
		</label>

		<div uiControl [ngClass]="styles.shortcutNameContainer">
			<input id="ewShortcut" name="shortcutName" type="text" class="form-control" [(ngModel)]="webcast.shortcutName" #ewShortcut="ngModel" pattern="^[a-zA-Z0-9\-]+$" minlength="5" [vbMaxLength]="50" [disabled]="isSidebar" [shortcutNameAsyncValidator]="shortcutValidator" [validatorData]="[
					webcast.startDate,
					webcast.endDate,
					webcast.lobbyTimeMinutes,
					webcast.preProduction?.durationMs
				]" trim="blur"/>

			<div class="help-block" [hidden]="!webcast.shortcutName || ewShortcut.invalid">
				{{ getShortcutUrl() }}
			</div>

			<div class="webcastCalenderIcon" [ngClass]="styles.shortcutCalendar" [hidden]="!webcast.shortcutName || !shortcutEvents?.length">
				<a uiSref="void" class="btn btn-transparent" (click)="showShortcutSchedule()" [attr.aria-label]="'Event_WebcastSchedules' | translate">
					<span class="glyphicons calendar"></span>
				</a>
			</div>

		</div>
		<div *ngIf="ewShortcut.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (ewShortcut.errors.minlength) {
				{{ 'Event_WebcastShortcutNameLengthNotValid' | translate }}
			}
			@if (ewShortcut.errors.vbMaxLength) {
				{{ 'Event_WebcastShortcutNameLengthNotValid' | translate }}
			}
			@if (ewShortcut.errors.pattern) {
				{{ 'Event_WebcastShortcutNameNotValid' | translate }}
			}
			@if (ewShortcut.errors.shortcutNameInUse) {
				{{ 'Event_WebcastShortcutNameAvailabilityNotValid' | translate }}
			}
		</div>
	</vb-ui-horizontal-form-group>



	<vb-ui-horizontal-form-group>
		<label #uiLabel>{{ 'Description' | translate }}</label>
		<div uiControl>
			<vb-ui-html-editor [attr.aria-label]="'Description' | translate" name="description" [(ngModel)]="webcast.description">
			</vb-ui-html-editor>
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label #uiLabel [ngClass]="styles.startEndLabel">{{ 'Event_Start' | translate }}</label>
		<div uiControl *ngIf="isScheduled">
			<vb-date-time-picker name="startDate" [ngClass]="styles.noZIndex" required [accessibilityLabel]="'Event_Start' | translate" [timezoneId]="webcast.timezoneId" [minuteStep]="15" [(ngModel)]="webcast.startDate" #ewStartDate="ngModel" (ngModelChange)="onStartDateTimeChange()" [vbValidationConditions]="{
					shortcut: ewShortcut?.errors?.shortcutNameInUse,
					profile: externalErrors?.presentationProfileConflict
				}">
			</vb-date-time-picker>
			<div *ngIf="ewStartDate.invalid" role="alert" vbUiErrorMessage uiValidation>
				@if (ewStartDate.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				} @else if (ewStartDate.errors.profile) {
					{{ 'Event_ResourceConflictError' | translate }}
				} @else if (ewStartDate.errors.shortcut) {
					{{ 'Event_WebcastShortcutNameAvailabilityNotValid' | translate }}
				}
			</div>
		</div>
		<div uiControl *ngIf="!isScheduled">
			{{ webcast.startDate | vbDateTimeMedium }}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label #uiLabel [ngClass]="styles.startEndLabel">{{ 'Event_End' | translate }}</label>
		<div uiControl *ngIf="isScheduled">
			<vb-date-time-picker name="endDate" [ngClass]="styles.noZIndex" required [accessibilityLabel]="'Event_End' | translate" [timezoneId]="webcast.timezoneId" [minuteStep]="15" [(ngModel)]="webcast.endDate" #ewEndDate="ngModel" (ngModelChange)="onEndDateTimeChange()" [vbValidationConditions]="{
					minDate: webcast.endDate && webcast.startDate && webcast.startDate >= webcast.endDate
				}">
			</vb-date-time-picker>
			<div *ngIf="ewEndDate.invalid" role="alert" vbUiErrorMessage uiValidation>
				@if (ewEndDate.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				} @else if (ewEndDate.errors.minDate) {
					{{ 'Event_InvalidEndDate' | translate }}
				} @else if (ewEndDate.errors.automatedDateInPast) {
					{{ 'Event_AutomatedWebcastDateInPast' | translate }}
				}
			</div>
		</div>
		<div uiControl *ngIf="!isScheduled">
			{{ webcast.endDate | vbDateTimeMedium }}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label for="ewTimezone" #uiLabel>{{ 'Event_Timezone' | translate }}</label>
		<select uiControl class="selectize-style form-select" id="ewTimezone" name="ewTimezone" [disabled]="!isScheduled" [(ngModel)]="webcast.timezoneId">
			<option [ngValue]="undefined">{{ 'Event_TimezoneDefault' | translate }}</option>
			<option *ngFor="let timezone of TimezoneCodes" [ngValue]="timezone.id">{{ timezone.name }}</option>
		</select>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group>
		<label for="ewLobbyTime" #uiLabel>
			{{ 'Event_LobbyTimeLabel' | translate }}
		</label>
		<div uiControl>
			<vb-ui-duration-input id="ewLobbyTime" class="vb-input-field" name="lobbyTime" [(ngModel)]="webcast.lobbyTimeMinutes" (ngModelChange)="validateShortcutSchedule()" required [vbMax]="maxLobbyDurationTimeMs" [default]="lobbyTimeDefault" [disabled]="!isScheduled" [asMinutes]="true">
			</vb-ui-duration-input>
			<div [ngClass]="styles.helpBlock">{{ 'Event_LobbyTimeHelp' | translate }}</div>
		</div>
	</vb-ui-horizontal-form-group>
	<div class="form-group row">
		<label class="control-label col-sm-3" id="ewPreProductionOptions">{{ 'PreProduction' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup *ngIf="isScheduled" aria-labelledby="ewPreProductionOptions">
						<button type="button" class="btn btn-admin btn-white" name="preProductionEnabled" [(ngModel)]="preProductionEnabled" (ngModelChange)="onPreProductionChanged()" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-admin btn-white" name="preProductionDisabled" [(ngModel)]="preProductionEnabled" (ngModelChange)="onPreProductionChanged()" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
					<div class="vb-input-field" *ngIf="!isScheduled">
						{{
							(preProductionEnabled ? 'UI_Enabled' : 'UI_Disabled') | translate
						}}
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="webcast.preProduction">
		<vb-ui-horizontal-form-group>
			<label for="ewPreProdDuration" #uiLabel>
				{{ 'Event_PreProductionDuration' | translate }}
				<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Edit_PreProdDuration_Tooltip' | translate">
				</vb-ui-tooltip>
			</label>

			<div uiControl>
				<vb-ui-duration-input id="ewPreProdDuration" class="vb-input-field" name="preProdDuration" required [(ngModel)]="webcast.preProduction.durationMs" #ewPreProdDuration="ngModel" (ngModelChange)="validateShortcutSchedule()" [default]="durationDefault" [disabled]="!isScheduled" [vbMin]="minDuration" [vbMax]="MaxPreProductionTimeMs">
				</vb-ui-duration-input>
			</div>
			<div *ngIf="ewPreProdDuration.invalid" role="alert" vbUiErrorMessage uiValidation>
				@if (ewPreProdDuration.errors.vbMin) {
					{{ 'Event_LobbyTime_PreProd_Invalid' | translate }}
				} @else if (ewPreProdDuration.errors.vbMax) {
					{{ 'Event_PreProductionMaxError' | translate : { '0': MaxPreProductionTimeHours } }}
				}
			</div>
		</vb-ui-horizontal-form-group>

		<div class="form-group row">
			<label class="control-label col-sm-3">{{ 'Event_PreProductionAttendees' | translate }}</label>
			<div class="col-sm-9">
				<div class="row">
					<div class="col-md-6 col-sm-9">
						<span class="help-block">{{ 'Event_PreProductionAttendees_HelpText' | translate }}</span>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 col-sm-9">
						<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
							<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
						</ng-template>

						<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
							<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
						</ng-template>
						<insight [attr.aria-label]="'Event_PreProductionAttendeesSelect' | translate" [insightOptions]="preProdAttendeesInsightOptions" class="insight-listing" [(ngModel)]="webcast.preProduction.attendees" name="preProductionAttendees" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow">
						</insight>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row">
		<label class="control-label col-sm-3" id="ewFeatured">
			{{ 'Event_Featured' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Featured_Help' | translate">
			</vb-ui-tooltip>
		</label>

		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					@if(!isSidebar && canEditEvents) {
						<div vbUiRadioBtnGroup aria-labelledby="ewFeatured">
							<button type="button" class="btn btn-admin btn-white" name="isFeaturedEnabled" [(ngModel)]="webcast.isFeatured" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
								{{ 'UI_Enabled' | translate }}
							</button>
							<button type="button" class="btn btn-admin btn-white" name="isFeaturedDisabled" [(ngModel)]="webcast.isFeatured" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
								{{ 'UI_Disabled' | translate }}
							</button>
						</div>
					}
					@else {
						<span>
							{{ (webcast.isFeatured ? 'UI_Enabled' : 'UI_Disabled') | translate }}
						</span>
					}
				</div>
			</div>
		</div>
	</div>

	<div class="form-group row">
		<label class="control-label col-sm-3" id="ewShowEventSharingLink">{{ 'ShowEventSharingLink' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup *ngIf="!isSidebar" aria-labelledby="ewShowEventSharingLink">
						<button type="button" class="btn btn-admin btn-white" name="showEventSharingLinkEnabled" [(ngModel)]="webcast.hideShareUrl" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-admin btn-white" name="showEventSharingLinkDisabled" [(ngModel)]="webcast.hideShareUrl" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
							{{ 'UI_Disabled' | translate }}
						</button>
					</div>
					<span *ngIf="isSidebar">
						{{ (!webcast.hideShareUrl ? 'UI_Enabled' : 'UI_Disabled') | translate }}
					</span>
				</div>
			</div>
		</div>
	</div>

	<!-- <vb-ui-category-settings
		*ngIf="categories"
		categories="categories"
		filter-assignable="true"
		[(ngModel)]="webcast.categories">
	</vb-ui-category-settings>] -->

	<vb-ui-horizontal-form-group *ngIf="categories">
		<label #uiLabel for="vbCategoryTagsInput">{{ 'Media_Videos_Settings_Categories' | translate }}</label>
		<vb-categories-tags-input uiControl id="vbCategoryTagsInput" name="vbCategoryTagsInput" [whitelist]="categories" [placeholder]="'Media_Videos_Settings_Categories' | translate" [(ngModel)]="webcast.categories">
		</vb-categories-tags-input>
	</vb-ui-horizontal-form-group>


	<vb-ui-horizontal-form-group *ngIf="features.enableTags">
		<label #uiLabel for="vbTagsInput">{{ 'Tags' | translate }}</label>
		<vb-tags-input uiControl id="vbTagsInput" name="vbTagsInput" [placeholder]="'TagsInputPlaceholder' | translate" [(ngModel)]="webcast.tags">
		</vb-tags-input>
	</vb-ui-horizontal-form-group>

	<edit-webcast-custom-fields name="ewCustomFields" [(ngModel)]="webcast.customFields">
	</edit-webcast-custom-fields>
</div>
